import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Facility } from '../../models/facility';
import { FacilityService } from '../../services/facility.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.css']
})
export class FacilityComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerFacility: PageHeader;
  entity: Facility = new Facility();
  editingEntity: Facility = new Facility();
  selectedFacility: Facility = new Facility();
  facilitys: any;
  facilityColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  opened: boolean = false;
  details: any;
  constructor(
    private _facilityService: FacilityService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerFacility = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.facilitys = [];
    this.getAllFacilitys();
  }
  ngAfterViewInit(): void {
    this.facilityColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 50 },
      { field: "FacilityName", title: 'Facility Name', filter: true, sortable: true, width: 120 },
      { field: "Description", title: 'Description', filter: true, sortable: true, width: 120 },
      // { field: "Unit", title: 'Unit', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._facilityService.getAllFacility('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Facility>) => {
      this.facilitys = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._facilityService.getAllFacility(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((facilitys: Array<Facility>) => {
        this.facilitys = {
          data: facilitys,
          total: facilitys[0] ? facilitys[0].TotalCount : 0
        }
      });
    }
  }
  getAllFacilitys() {
    this._facilityService.getAllFacility('', Number(this.defaultPageSize), 1, 0, 0).subscribe((facilitys: Array<Facility>) => {
      this.facilitys = {
        data: facilitys,
        total: facilitys[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._facilityService.deleteFacility(this.selectedFacility.Facility_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearFacility();
            this.getAllFacilitys();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerFacility = new PageHeader();
    headerFacility.PageCaption = "Facility";
    headerFacility.IconClass = "bi bi-building";
    return headerFacility;
  }

  deleteFacility(event: any) {
    if (event.seletedRows[0]) {
      this.selectedFacility.Facility_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Facility",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addFacility(event: any) {
    this.listView = false;
    this.clearFacility();
    this.formCaption = "Add Facility";
  }

  editFacility(event: any): void {
    if (event.seletedRows[0]) {
      this._facilityService.viewFacility(event.seletedRows[0]).subscribe((facilitys: Array<Facility>) => {
        let editFacility = facilitys[0] ? facilitys[0] : new Facility();
        if (editFacility) {
          this.editingEntity = editFacility;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Facility";
          this.entity.EntityMetaData = [
            { FieldName: 'FacilityName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Facility Name is required' },
            //{ FieldName: 'Unit', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Unit is required' },

          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._facilityService.checkDuplication(this.entity.FacilityName, this.entity.Facility_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Facility already exists');
          this.saveDisabled = false;
        }
        else {
          this._facilityService.saveFacility(this.entity).subscribe(() => {
            if (this.entity.Facility_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearFacility();
            this.getAllFacilitys();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.clearFacility();
  }
  refreshFacility(event: any): void {
    this.facilitys=[];
    this.getAllFacilitys();
  }
  clearFacility(): void {
    this.entity = new Facility();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Facility_Id = dataItem.Facility_Id;
    this.details = [];
    this._facilityService.viewFacility(this.entity.Facility_Id).subscribe((facilitys: Array<Facility>) => {
      this.opened = true;
      this.details = facilitys[0];
    })}
}
